// src/components/ui/panels/PanelContent/PanelContentShadcn.jsx
import React from 'react';
import { cn } from '../../../../utils/cn';

const PanelContentShadcn = ({
  children,
  padding = 'default', // 'none', 'sm', 'default', 'lg'
  className = '',
  ...props
}) => {
  // Padding configurations
  const paddingConfig = {
    none: '',
    sm: 'p-4',
    default: 'p-6', // Extracted from old EventCreationPanel
    lg: 'p-8'
  };

  return (
    <div
      className={cn(
        // Exact scrollable content styling from old EventCreationPanel
        "flex-1 overflow-y-auto",
        paddingConfig[padding],
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};

export default PanelContentShadcn;